import { SelectBox, Input, Stack } from '@etg/wings';
import { cx } from '@eti/styles';
import { Field as ReduxFormField } from 'redux-form';
import { useTranslation, useValidation } from '@eti/providers';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SelectBoxComponent = _ref => {
  let {
    className,
    description,
    input,
    isMultiple,
    label,
    meta,
    name,
    shouldMarkInputAsRequired,
    ...rest
  } = _ref;
  const {
    nonDebugT
  } = useTranslation();
  const hasError = Boolean(meta.invalid && !meta.active && (input.value !== '' || meta.touched));
  const hasWarning = Boolean(meta.warning && !meta.active && (input.value !== '' || meta.touched));
  const errorId = `${name}-error`;
  const descriptionId = description ? `${name}-description` : undefined;
  const resolvedLabel = shouldMarkInputAsRequired ? nonDebugT('Input.Field.Required', label) : label;
  const {
    value
  } = input;
  return /*#__PURE__*/_jsxs(Stack, {
    className: cx(className, 'etiSelectBox', hasError && 'error'),
    spacing: 4,
    children: [/*#__PURE__*/_jsx(SelectBox, {
      descriptionId: descriptionId,
      errorId: errorId,
      hasError: hasError,
      hasWarning: hasWarning,
      isMultiple: isMultiple,
      label: resolvedLabel,
      required: Boolean(shouldMarkInputAsRequired),
      ...rest,
      ...input,
      value: isMultiple && value === '' ? [] : value
    }), (Boolean(shouldMarkInputAsRequired) || descriptionId) && /*#__PURE__*/_jsx(Input.Meta, {
      description: description,
      descriptionId: descriptionId,
      error: meta.error,
      errorId: errorId,
      hasError: hasError,
      hasWarning: hasWarning,
      warning: meta.warning
    })]
  });
};
const ConnectedSelectBox = _ref2 => {
  let {
    format,
    name,
    normalize,
    onBlur,
    onChange,
    onFocus,
    validationRuleName,
    warningRuleName,
    ...props
  } = _ref2;
  const validate = useValidation(validationRuleName);
  const warning = useValidation(warningRuleName);
  return /*#__PURE__*/_jsx(ReduxFormField, {
    component: SelectBoxComponent,
    format: format,
    name: name,
    normalize: normalize,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    props: {
      name,
      ...props
    },
    validate: validate,
    warn: warning
  });
};
export default ConnectedSelectBox;
//# sourceMappingURL=ConnectedSelectBox.js.map